import { render } from "./toptenholder-count.vue?vue&type=template&id=4a0911b6&scoped=true"
import script from "./toptenholder-count.vue?vue&type=script&lang=js"
export * from "./toptenholder-count.vue?vue&type=script&lang=js"

import "./toptenholder-count.vue?vue&type=style&index=0&id=4a0911b6&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0911b6"]])

export default __exports__